import React, { useState, useEffect } from "react"
import PropTypes from "prop-types"
import {
  Dropdown,
  DropdownToggle,
  DropdownMenu,
  DropdownItem,
} from "reactstrap"

//i18n
import { withTranslation } from "react-i18next"
// Redux
import { connect } from "react-redux"
import { Link } from "react-router-dom"
import withRouter from "components/Common/withRouter"

// users
import user1 from "../../../assets/images/users/avatar-9.png"
import Configs from "../../../config"
import secureLocalStorage from "react-secure-storage"

const ProfileMenu = props => {
  // Declare a new state variable, which we'll call "menu"
  const [menu, setMenu] = useState(false)

  const [user, setUser] = useState(secureLocalStorage?.getItem("admin_user"))

  return (
    <React.Fragment>
      <Dropdown
        isOpen={menu}
        toggle={() => setMenu(!menu)}
        className="d-inline-block"
      >
        <DropdownToggle
          className="btn header-item text-white"
          id="page-header-user-dropdown"
          tag="button"
        >
          <img
            className="rounded-circle header-profile-user"
            src={
              user?.profilePicture
                ? `${Configs.imageUrl}${user?.profilePicture}`
                : user1
            }
            alt="Header Avatar"
          />
          <span className="d-none d-xl-inline-block ms-2 me-1 fw-bold fs-6 text-dark">
            {user?.name}
          </span>
          <i className="mdi mdi-chevron-down d-none d-xl-inline-block text-dark fs-6 fw-bold" />
        </DropdownToggle>
        <DropdownMenu className="dropdown-menu-end">
          {/* <DropdownItem tag="a" href={`${Configs.appurl}profile`}>
            {" "}
            <i className="bx bx-user font-size-16 align-middle me-1" />
            {"Profile"}{" "}
          </DropdownItem> */}

          {/* <div className="dropdown-divider" /> */}
          <Link to={`${Configs.appurl}login`} className="dropdown-item">
            <i className="bx bx-power-off font-size-16 align-middle me-1 text-danger" />
            <span>{"Logout"}</span>
          </Link>
        </DropdownMenu>
      </Dropdown>
    </React.Fragment>
  )
}

ProfileMenu.propTypes = {
  success: PropTypes.any,
  t: PropTypes.any,
}

export default ProfileMenu
